import { PCUser as ServerPCUser } from 'server/models/PCUser';
export { PCUserData, PCUserOptions } from 'server/models/PCUser';
import { PhoneNumberKind } from 'server/enums/PhoneNumberKind';

export class PCUser extends ServerPCUser {
    FullName() {
        return this.FirstName() + ' ' + this.LastName();
    }

    AbbreviatedName() {
        return (this.FirstName() ? `${this.FirstName()[0]}. ` : '') + this.LastName();
    }

    EffectiveUITheme() {
        return this.UITheme() || this.DefaultUITheme();
    }

    DefaultUITheme() { 
        const org = this.Organization(),
            orgTheme = org && org.UITheme();
            
        if (orgTheme) return orgTheme;

        const domain = org && org.Domain(),
            dsettings = domain && domain.Settings(),
            defaultTheme = dsettings && dsettings.DefaultUITheme();

        return defaultTheme;
    }

    MainPhoneNumber() {
        const numbers = this.PhoneNumbers(),
            mobiles = numbers.filter(pn => pn.Kind() === PhoneNumberKind.Mobile);
        // Logic for "main" phone number taken from personprofilepopup
        return mobiles[0] || numbers[0] || null;
    }

    OtherPhoneNumbers() {
        const main = this.MainPhoneNumber();
        return this.PhoneNumbers().filter(pn => pn !== main);
    }
}


// WEBPACK FOOTER //
// ./data/models/PCUser.ts